/**
 * @generated SignedSource<<4fec337373ad296dbbff96f3aef31764>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraJQLBuilderSearchMode = "ADVANCED" | "BASIC" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_jqlBuilder_JQLBuilder$data = {
  readonly jqlBuilderSearchMode: JiraJQLBuilderSearchMode | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderUI_userPreferences">;
  readonly " $fragmentType": "main_jqlBuilder_JQLBuilder";
};
export type main_jqlBuilder_JQLBuilder$key = {
  readonly " $data"?: main_jqlBuilder_JQLBuilder$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_jqlBuilder_JQLBuilder">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_jqlBuilder_JQLBuilder",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "JQLBuilderUI_userPreferences"
    },
    {
      "kind": "ScalarField",
      "name": "jqlBuilderSearchMode"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "8bf129a7c3b1c50291742bf55ecb6087";

export default node;
